import React from "react";
import { useNavigate } from "react-router-dom";
import img4 from '../../assets/img4.jpg';
import img1 from '../../assets/img1.jpg';
import blockchainImg from '../../assets/blockchain.png';
import squareImg from '../../assets/square.png';

export default function ImagesSection({ 
  firstImageAnimated, 
  secondImageAnimated, 
  floatingElementsAnimated, 
  textOverlaysAnimated 
}) {
   const navigate = useNavigate();

  const handleImageClick = () => {
    navigate('/about');
  };
  return (
    <>
      <div className="images-section">
        <ImageContainer 
          image={img4}
          alt="AI Technology"
          className="first-image"
          animated={firstImageAnimated}
          overlayClass="first-overlay"
          onClick={handleImageClick}
        />
        
        <ImageContainer 
          image={img1}
          alt="Office Environment"
          className="second-image"
          animated={secondImageAnimated}
          overlayClass="second-overlay"
          onClick={handleImageClick}
        />

        <TextOverlay 
          position="right"
          animated={textOverlaysAnimated}
          title="Innovation"
          text="Cutting-edge technology solutions"
        />

        <TextOverlay 
          position="left"
          animated={textOverlaysAnimated}
          title="Excellence"
          text="Quality-driven development"
        />

        <FloatingElements animated={floatingElementsAnimated} />

        {/* Mobile Decorative Images */}
        <MobileDecorativeImages animated={firstImageAnimated} />
      </div>

      <style jsx>{`
        /* Mobile Decorative Images - Only visible on mobile */
        .mobile-decorative-container {
          display: none;
        }

        @media (max-width: 968px) {
          .mobile-decorative-container {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1;
          }

          .decorative-image {
            position: absolute;
            opacity: 1;
            transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
          }

          .decorative-image.animate-decorative {
            opacity: 1;
          }

          .decorative-right {
            top: 50%;
            right: -20px;
            width: 120px;
            height: 120px;
            transform: translateY(-50%) scale(0.5);
            animation: pulseRotate 4s ease-in-out infinite;
          }

          .decorative-left {
            top: 50%;
            left: -20px;
            width: 100px;
            height: 100px;
            transform: translateY(-50%) scale(0.5);
            animation: pulseRotate 4s ease-in-out infinite 2s;
          }

          .decorative-image.animate-decorative.decorative-right {
            transform: translateY(-50%) scale(1);
          }

          .decorative-image.animate-decorative.decorative-left {
            transform: translateY(-50%) scale(1);
          }

          .decorative-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          @keyframes pulseRotate {
            0%, 100% {
              transform: translateY(-50%) scale(1) rotate(0deg);
              filter: drop-shadow(0 0 20px rgba(0, 120, 255, 0.3));
            }
            50% {
              transform: translateY(-50%) scale(1.15) rotate(180deg);
              filter: drop-shadow(0 0 30px rgba(0, 120, 255, 0.5));
            }
          }
        }

        @media (max-width: 768px) {
          .decorative-right {
            width: 100px;
            height: 100px;
            right: -15px;
          }

          .decorative-left {
            width: 85px;
            height: 85px;
            left: -15px;
          }
        }

        @media (max-width: 480px) {
          .decorative-right {
            width: 150px;
            height: 150px;
            right: -10px;
            margin-top: -40px;
          }

          .decorative-left {
            width: 170px;
            height: 170px;
            left: -35px;
            margin-top: 120px;
          }
        }
      `}</style>
    </>
  );
}

// Updated ImageContainer Component with click handler
function ImageContainer({ image, alt, className, animated, overlayClass, onClick }) {
  return (
    <div 
      className={`image-container ${className} ${animated ? `animate-${className.split('-')[0]}` : ''}`}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="image-frame">
        <img src={image} alt={alt} className="main-image" />
        <div className={`image-overlay ${overlayClass}`}></div>
        <div className="shimmer-effect"></div>
      </div>
    </div>
  );
}

// Rest of the components remain the same...
function TextOverlay({ position, animated, title, text }) {
  return (
    <div className={`text-overlay ${position}-overlay ${animated ? 'animate-text' : ''}`}>
      <div className="overlay-content">
        <h3 className="overlay-title">{title}</h3>
        <p className="overlay-text">{text}</p>
      </div>
    </div>
  );
}

function FloatingElements({ animated }) {
  return (
    <div className={`floating-elements ${animated ? 'animate-float' : ''}`}>
      <div className="float-circle float-1"></div>
      <div className="float-circle float-2"></div>
      <div className="float-circle float-3"></div>
    </div>
  );
}

function MobileDecorativeImages({ animated }) {
  return (
    <div className="mobile-decorative-container">
      <div className={`decorative-image decorative-right ${animated ? 'animate-decorative' : ''}`}>
        <img src={blockchainImg} alt="Blockchain" className="decorative-img" />
      </div>
      <div className={`decorative-image decorative-left ${animated ? 'animate-decorative' : ''}`}>
        <img src={squareImg} alt="Technology" className="decorative-img" />
      </div>
    </div>
  );
}